import styled from 'styled-components'

import { Box } from '@usap/uicomponents'

export const Container = styled(Box)`
  min-height: 350px;
  background: #F4F4F4;
  padding-bottom: 24px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding-bottom: 9px;
    min-height: ${props => (props.isFlagEnabled ? '60%' : '450px')};
  }
`
export const CartBox = styled.div`
  background: #F4F4F4;
  margin: 40px auto 0 auto;
  box-sizing: border-box;
  width: 100%;
  padding: 0 12px 0 12px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    max-width: 1384px;
    margin-top: 40px;
  }
`
